import { render, staticRenderFns } from "./price-market-price.vue?vue&type=template&id=60a86a86&scoped=true"
import script from "./price-market-price.vue?vue&type=script&lang=js"
export * from "./price-market-price.vue?vue&type=script&lang=js"
import style0 from "./price-market-price.vue?vue&type=style&index=0&id=60a86a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a86a86",
  null
  
)

export default component.exports